<template>
    <div class="TQ_center"
         ref="ongoing_quest_cards"
         :style="{'direction' : helper_getDirectionByLangCode_fe(p_system_langCode_e)}">

        <tq-card width="100%"
                 class="TQ_maxWidth_600px "
                 :class="{'lc_riddleMargin' : co_showBottomLocation_b}"
                 margin="12px"
                 v-for="(riddleIndex, index) in p_availableRiddlesIndexes_a"
                 :key="index"
                 v-if="index === currentRiddleIndex">

            <tq-riddle-data
                    :p_name_s="riddleIndex + ''"
                    :p_system_lang-code_e="p_system_langCode_e"
                    :p_qb_display-lang-code_e="p_qb_displayLangCode_e"
                    :p_user-id_uid="p_currentUserId_uid"
                    :p_window-size_e="p_system_windowSizeType_en"

                    :p_qb_riddle_c="p_qb_riddles_ac[riddleIndex]"
                    :p_riddle-metadata_c="p_qb_riddles_ac[riddleIndex].qbr_metadata_c"

                    :p_riddle-status_c="p_riddlesStatus_byRiddleIndex_c[riddleIndex]"

                    :p_team-status_sub-collection_e="p_teamStatus_subCollection_e"

                    :p_clues-left_n="p_cluesLeft_n"
                    :p_skips-left_n="p_skipsLeft_n"

                    :p_current-user-location_c="p_currentUserLocation_c"

                    :p_showSkip_b="p_showSkip_b"
                    :p_cards-mode_b="true"

                    :p_qb_metadata_c="p_qb_metadata_c"

                    :p_click-get-clue_f="(clueIndex, cb_f) => {p_clickGetClue_f(riddleIndex, clueIndex, cb_f)}"
                    :p_click-skip-riddle_f="(unlocksData_byLockId, cb_f)=> {p_clickSkipRiddle_f(riddleIndex, unlocksData_byLockId, cb_f)}"
                    :pe_rs_unlock-data_update_f="(lockIndex_n, rs_unlocksData_c, cb_f) => {p_updateRiddleLockAnswer_f(riddleIndex,lockIndex_n, rs_unlocksData_c, cb_f)}"

                    :pe_start-watch-position_f="pe_startWatchPosition_f"
                    :pe_stop-watch-position_f="pe_stopWatchPosition_f"
                    :pe_click-image_f="ppe_clickImage_f"
            />
        </tq-card>

        <div v-if="p_showNavBtns_b">

            <div class="lc_left TQ_btn TQ_box_shadow TQ_border TQ_center TQ_bg_white TQ_borderRadius"
                 :style="{'zIndex' : gv_zIndex.ongoing_cards_navBarBtns, width: co_navBtnWidth_s}"
                 :class="{'TQ_bg_purple' : forwardBtn('left')}"
                 @click="swipeHandler('left')"
                 v-if="showCardsNavBtn('left')">
                <img :src="forwardBtn('left') ? ass_img_leftArrow_w : ass_img_leftArrow" class="TQ_width_100p">
            </div>

            <div class="lc_right TQ_btn TQ_box_shadow TQ_border TQ_center TQ_bg_white TQ_borderRadius"
                 :style="{'zIndex' : gv_zIndex.ongoing_cards_navBarBtns,  width: co_navBtnWidth_s}"
                 :class="{'TQ_bg_purple' : forwardBtn('right')}"
                 @click="swipeHandler('right')"
                 v-if="showCardsNavBtn('right')">
                <img :src="forwardBtn('right') ? ass_img_rightArrow_w : ass_img_rightArrow" class="TQ_width_100p">
            </div>

        </div>

        <div class="lc_bottom TQ_bg_white TQ_borderBox TQ_box_shadow TQ_text_bold TQ_direction_ltr TQ_bg_purple_dark TQ_border "
             :class="p_system_windowSizeType_en > enum_screenSizesOptions_n.tablet_small ? 'TQ_text_20px TQ_padding_8px' : 'TQ_text_16px TQ_padding_4px'"
             v-if="co_showBottomLocation_b">
            {{currentRiddleIndex+1}} / {{p_totalRiddleNum_n}}
        </div>

    </div>

</template>

<script>
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import TqCard from "../../../components/basic/TqCard";
    import {helper_getDirectionByLangCode_fe} from "../../../scripts/S_Helper";
    import {
        enum_cluesMode_e,
        enum_directions, enum_subCollection_teamStatus
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../../functions/src/shareCode/Share_S_Validator";
    import {
        ass_img_arrow_left_b,
        ass_img_arrow_left_w,
        ass_img_arrow_right_b,
        ass_img_arrow_right_w
    } from "../../../assets/scripts/Ass_Files";
    import {store_var, store_setStateValue} from "../../../store";
    import {gv_zIndex} from "../../../scripts/S_GlobalVar";
    import {validator_arrayClass_fb} from "../../../../functions/src/shareCode/Share_S_Validator";
    import {gv_numbers} from "../../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {enum_cardsDirections, enum_langCodes, enum_screenSizesOptions_n} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {route_scrollToTop_f} from "../../../router";
    import {
        FB_MapData,
        FB_QuestBody_Metadata,
        FB_QuestBody_Riddle, FB_UserGeoLocation
    } from "../../../../functions/src/shareCode/Share_S_Classes";
    export default {
        name: "C_Ongoing_Quest_CardsRiddles",
        components: {
            TqCard,
            TqRiddleData
        },
        props:{

            ppe_clickImage_f:{},

            // ========= basic ============
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_qb_displayLangCode_e  : {
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_system_displayKeyboard_b:{
                type: Boolean,
                require: true
            },
            p_system_windowSizeType_en:{
                type: Number,
                require: true,
                validator(val_e){
                    return validator_enum_fb(enum_screenSizesOptions_n, val_e)
                }
            },
            p_teamStatus_subCollection_e  : {
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_subCollection_teamStatus, val)
                }
            },

            p_showNavBtns_b:{
                type: Boolean,
                default: true
            },
            p_currentUserLocation_c:{
                type: FB_UserGeoLocation,
                require:true,
            },
            p_currentUserId_uid:{
                type:String,
                require: true
            },

            // ========= riddles ============
            p_qb_riddles_ac:{
                type: Array,
                require: true,
                validator(val){
                    return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                }
            },
            p_showSkip_b:{
                type: Boolean,
                default: true
            },
            p_qbr_mapData_ac:{
                type: Array,
                require: true,
                validator(val){
                    return validator_arrayClass_fb(val, FB_MapData)
                }
            },
            p_availableRiddlesIndexes_a:{
                type: Array,
                require: true
            },
            p_totalRiddleNum_n:{
                type: Number,
                require: true
            },

            // ========= riddles status ============

            p_riddlesStatus_byRiddleIndex_c:{
                type: Object,
                require: true
            },
            p_qb_metadata_c :{
                type: FB_QuestBody_Metadata,
                require: true,
            },
            p_cluesLeft_n :{
                type: Number,
                require: true
            },
            p_skipsLeft_n :{
                type: Number,
                require: true
            },
            p_currentRiddleIndex_n:{
                type: Number,
                default: 0
            },

            // ========= functions ============
            p_clickGetClue_f:{
                type: Function,
                require: true
            },
            p_clickSkipRiddle_f:{
                type: Function,
                require: true
            },
            p_updateRiddleLockAnswer_f:{
                type: Function,
                require: true
            },
            pe_startWatchPosition_f:{
                type: Function,
            },
            pe_stopWatchPosition_f:{
                type: Function,
            },

        },
        data(){
            return {

                currentRiddleIndex      : this.p_currentRiddleIndex_n,

                enum_numbers            : gv_numbers,
                gv_zIndex               : gv_zIndex,
                ass_img_leftArrow_w     : ass_img_arrow_left_w,
                ass_img_leftArrow       : ass_img_arrow_left_b,
                ass_img_rightArrow_w    : ass_img_arrow_right_w,
                ass_img_rightArrow      : ass_img_arrow_right_b,
                enum_screenSizesOptions_n      : enum_screenSizesOptions_n,
                enum_subCollection_teamStatus      : enum_subCollection_teamStatus,

                helper_getDirectionByLangCode_fe: helper_getDirectionByLangCode_fe,

            }
        },
        computed:{
            co_navBtnWidth_s(){

                if(this.p_system_windowSizeType_en === enum_screenSizesOptions_n.mobile){
                    return "32px"
                }

                if(this.p_system_windowSizeType_en === enum_screenSizesOptions_n.tablet_small){
                    return "52px"
                }

                return "72px"
            },
            co_showBottomLocation_b(){
                return this.p_qb_riddles_ac.length>1
            }
        },
        methods:{

            // dom
            showCardsNavBtn(direction){

                if(this.p_system_displayKeyboard_b){
                    return false
                }

                if(this.forwardBtn(direction)){
                    return this.currentRiddleIndex < this.p_availableRiddlesIndexes_a.length - 1
                }else{
                    return this.currentRiddleIndex > 0
                }

            },
            getNavBtnText(direction){

                if(this.forwardBtn(direction)){
                    return ass_strings.oneWord_next[this.p_system_langCode_e]
                }else{
                    return ass_strings.oneWord_prev[this.p_system_langCode_e]
                }
            },
            forwardBtn(direction){
                let currentDirection = helper_getDirectionByLangCode_fe(this.p_system_langCode_e)

                switch (currentDirection){
                    case enum_directions.rtl:
                        switch (direction){
                            case enum_cardsDirections.left:
                                return true
                            case enum_cardsDirections.right:
                                return false
                        }
                        break;
                    case enum_directions.ltr:
                        switch (direction){
                            case enum_cardsDirections.left:
                                return false
                            case enum_cardsDirections.right:
                                return true
                        }
                }
            },

            // user events
            swipeHandler(direction){

                if(this.forwardBtn(direction)){
                    this.swipeHandler_forwardIndex()
                }else{
                    this.swipeHandler_backwardIndex()
                }
                route_scrollToTop_f()

            },

            // helper
            swipeHandler_forwardIndex(){
                if(this.p_availableRiddlesIndexes_a.length > this.currentRiddleIndex + 1){
                    this.currentRiddleIndex++
                    store_setStateValue(store_var.ongoing_cardsRiddles_lastIndex_n, this.currentRiddleIndex, false)
                }
            },
            swipeHandler_backwardIndex(){
                if(this.currentRiddleIndex > 0){
                    this.currentRiddleIndex--
                    store_setStateValue(store_var.ongoing_cardsRiddles_lastIndex_n, this.currentRiddleIndex, false)
                }

            },

        },


    }
</script>

<style scoped lang="scss">

    .lc_right{
        position: fixed;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        padding: 16px 4px;
    }

    .lc_left{
        position: fixed;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        padding: 16px 4px;

    }


    .lc_riddleMargin{
        margin-bottom: 32px;

    }


    .lc_bottom{
        position: fixed;
        bottom: var(--bottomBar);
        margin-bottom: 4px;


        width: 100%;
        left: 0;
    }

</style>